import React from "react";
import { Row } from "reactstrap";

const WarningNoteItem = ({ reason, noted_description, notesData }) => {
  const renderNote = note => {
    if (!note?.is_noted) return null;

    return (
      <div className="mb-2 p-2 border rounded bg-white shadow-sm">
        <Row className="g-0">
          <p className="mb-1">
            <strong className="text-dark">Lý do: </strong>
            <span className="text-muted">
              {note.reason_noted_name || "N/A"}
            </span>
          </p>
        </Row>
        {note.noted_description && (
          <Row className="g-0">
            <p className="mb-0">
              <strong className="text-dark">Lời nhắn: </strong>
              <pre
                className="p-2 mt-1 mb-0 border border-secondary-subtle fs-6 bg-light rounded-2"
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  fontFamily: "inherit",
                  lineHeight: "1.5",
                }}
              >
                {note.noted_description}
              </pre>
            </p>
          </Row>
        )}
      </div>
    );
  };

  if (notesData) {
    const { customer, transport_locality, order } = notesData;
    const hasAnyNote =
      customer?.is_noted || transport_locality?.is_noted || order?.is_noted;

    if (!hasAnyNote) return null;

    return (
      <div className="mt-2">
        {renderNote(customer)}
        {renderNote(transport_locality)}
        {renderNote(order)}
      </div>
    );
  }

  return (
    <div className="mt-2">
      <div className="p-2 border rounded bg-white shadow-sm">
        {reason && (
          <Row className="g-0">
            <p className="mb-1">
              <strong className="text-dark">Lý do: </strong>
              <span className="text-muted">{reason}</span>
            </p>
          </Row>
        )}
        {noted_description && (
          <Row className="g-0">
            <p className="mb-0">
              <strong className="text-dark">Lời nhắn: </strong>
              <pre
                className="p-2 mt-1 mb-0 border border-secondary-subtle fs-6 bg-light rounded-2"
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  fontFamily: "inherit",
                  lineHeight: "1.5",
                }}
              >
                {noted_description}
              </pre>
            </p>
          </Row>
        )}
      </div>
    </div>
  );
};

export default WarningNoteItem;
